export const ClientsConfig = [
    {
        name : 'AndiFOODmap',
        description: 'Me dedico a guiarte hacia tus objetivos de salud. Estoy aquí para escucharte, comprender tus necesidades únicas y brindarte el apoyo que mereces en tu viaje hacia el bienestar.',
        image : '/clients/andifoodmaps.webp',
        url : 'https://andifoodmap.com/'
    }
]